import { render } from "./OrderRefund.vue?vue&type=template&id=bebd9928&scoped=true"
import script from "./OrderRefund.vue?vue&type=script&lang=js"
export * from "./OrderRefund.vue?vue&type=script&lang=js"

import "./OrderRefund.vue?vue&type=style&index=0&id=bebd9928&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebd9928"]])

export default __exports__